// The picker's "can't move" list: plays grouped under the one item that stops them, so a
// single personal call sheet blocking twenty plays reads as one line, not twenty sentences.
export type Blocker = { key: string; kind: string; label: string; hint: string }
export type BlockedPlay = {
  public_id: string
  name: string
  reason: string | null
  blocker: Blocker | null
}
export type BlockerGroup = { blocker: Blocker; plays: BlockedPlay[] }

/** Groups by blocker key, biggest first; ties keep the order the server listed them. */
export function groupByBlocker(blocked: BlockedPlay[]): BlockerGroup[] {
  const groups = new Map<string, BlockerGroup>()
  for (const play of blocked) {
    // A play with no structured blocker (older server) falls back to its reason sentence.
    const blocker = play.blocker ?? {
      key: `reason:${play.reason ?? "unknown"}`,
      kind: "other",
      label: play.reason ?? "Something linked to it",
      hint: "Resolve what it is linked to, then reload.",
    }
    const group = groups.get(blocker.key)
    if (group) group.plays.push(play)
    else groups.set(blocker.key, { blocker, plays: [play] })
  }
  return [...groups.values()].sort((a, b) => b.plays.length - a.plays.length)
}
